'use strict'; // Set utils

var _regeneratorRuntime = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _toConsumableArray = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/toConsumableArray");

var difference = function difference(set1, set2) {
  return new Set(_toConsumableArray(set1).filter(function (x) {
    return !set2.has(x);
  }));
}; // Poll utils


var sleep = function sleep(time) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, time);
  });
};

var runWithDelay =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(func, topic, interval) {
    var peers;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return func(topic);

          case 2:
            peers = _context.sent;
            _context.next = 5;
            return sleep(interval);

          case 5:
            return _context.abrupt("return", peers);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function runWithDelay(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

module.exports.runWithDelay = runWithDelay;
module.exports.difference = difference;